<template>
  <v-form v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container md="12">
      <v-row dense>
        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-text-field
            type="text"
            label="群組名稱"
            dense
            clearable
            class="font-weight-normal"
            v-model="queryObject.name"
            @input="getInterpreterFromServer"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-select
            :items="getCodeDateUtil('articleStatus')"
            label="是否公開"
            dense
            clearable
            class="font-weight-normal"
            v-model="queryObject.status"
            @change="getInterpreterFromServer"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="pageSize"
            :loading="loading"
            :footer-props="{ itemsPerPageText:'每頁筆數' }"
            class="elevation-1"
            widths="1500"
            no-data-text="無資料"
            loading-text="資料傳輸中"
            hide-default-footer
            multi-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>
                  <v-row class="pa-3 ma-5" align="center" justify="center">
                    <v-col>
                    <span class="red--text">共 {{totalCount}} 筆，每頁筆數</span>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn dark text color="red" class="ml-2" v-on="on">
                          {{ itemsPerPage }}
                          <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(number, index) in itemsPerPageArray"
                          :key="index"
                          @click="updateItemsPerPage(number)"
                        >
                          <v-list-item-title>{{ number }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    </v-col>
                  </v-row>
                </v-toolbar-title>

                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" persistent max-width="1024">
                  <!-- <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on">新增</v-btn>
                  </template>-->
                  <v-card>
                    <v-card-title class="red" dark>
                      <h2>
                        <font style="color:white">修改</font>
                      </h2>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <tr v-for="item in finalObject" :key="item.id">
                          <td class="mx-2" v-if="item.second" v-cloak>
                            <v-checkbox
                              :key="item.id"
                              v-model="item.YN"
                              v-bind:false-value="0"
                              v-bind:true-value="1"
                              v-cloak
                              class="mx-2"
                              :label="item.title"
                              :value="item.id"
                            ></v-checkbox>
                          </td>
                          <td align="left" v-show="item.second&&!item.folded">
                            <v-row >
                              <v-checkbox
                                v-for="(second) in item.second"
                                :key="second.id"
                                v-model="second.YN"
                                v-bind:false-value="0"
                                v-bind:true-value="1"
                                v-cloak
                                class="mx-2"
                                :label="second.title"
                                :value="second.id"
                              ></v-checkbox>
                            </v-row>
                          </td>
                        </tr>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="grey lighten-3" style="color:black;" @click="canceldata();">取消</v-btn>
                      <v-btn color="red" style="color:white;" @click="savedata">儲存</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.status="{ item }">{{getColor(item.status)}}</template>
            <template v-slot:item.action="{ item }">
              <v-icon class="mr-2" @click="editItem(item)">edit</v-icon>
            </template>

            <template v-slot:footer>
              <div class="text-center pa-2 ma-2">
                <v-pagination
                  color="red"
                  v-model="currentPage"
                  :length="maxPage"
                  :total-visible="9"
                  @input="getInterpreterFromServer()"
                ></v-pagination>
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
// import InterpreterDetail from "../Common/InterpreterDetail";
import { mapGetters, mapActions } from "vuex";
import { Checkbox } from "element-ui";

export default {
  components: {
    [Checkbox.name]: Checkbox
    // InterpreterDetail
  },
  computed: {
    ...mapGetters({
      getTargetCaseId: ["getTargetCaseId"],
      idbServerUrl: ["getIdbServerUrl"]
    }),
  },
  data() {
    return {
      editedItem: {},
      defaultItem: {},
      finalObject: [],
      dialog: false,
      valid: false,
      loading: false,
      options: {},
      items: [],
      queryObject: {},
      queryPager: {
        pageSize: 100,
        currentPage: 1,
        // options: [20, 50, 100],
        // total: 0,
        sortColumnNameList: ["-postDate"]
      },

      itemsPerPageArray: [5, 10, 30, 50],
      currentPage: 1,
      itemsPerPage: 5,
      maxPage: 0,
      pageSize: 10,
      totalCount: 0,
      criterion: {},
      headers: [
        { text: "群組ID", value: "roleId" },
        { text: "群組名稱", value: "name" },
        { text: "是否公開", value: "status" },
        { text: "動作", value: "action", sortable: false }
      ]
    };
  },
  watch: {
    options: {
      handler() {
        this.getInterpreterFromServer();
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(["updateTargetCaseId"]),
    
    getColor(value) {
      if (value == "Y") {
        return "公開";
      } else if (value == "N") {
        return "不公開";
      } else {
        return value;
      }
    },

    editItem(item) {
      var vm = this;
      this.editedItem = Object.assign({}, item);
      vm.finalObject = [];
      vm.getTableDataFormServer(item);
      this.dialog = true;
    },
    canceldata() {
      this.dialog = false;
      this.editedItem = {};
    },
    savedata() {
      var vm = this;
      vm.funcPermissionbject = [];

      for (let d = 0; d < vm.finalObject.length; d++) {
        if (vm.finalObject[d].YN == "1") {
          var objTmpIndex = {
            targetName: vm.editedItem.creatorName,
            funcId: vm.finalObject[d].id,
            targetType: "DEF"
          };
          console.log("objTmp" + objTmpIndex);
          vm.editedItem.authFuncPermissionList.push(objTmpIndex);
        }
      }
      //console.log(JSON.stringify(vm.editedItem.authFuncPermissionList));
      //console.log("vm.ugrpIdArray.length" + vm.finalObject.length);
      for (let b = 0; b < vm.finalObject.length; b++) {
        if (vm.finalObject[b].second.length > 0) {
          for (let c = 0; c < vm.finalObject[b].second.length; c++) {
            if (vm.finalObject[b].second[c].YN == "1") {
              var objTmp = {
                targetName: vm.editedItem.creatorName,
                funcId: vm.finalObject[b].second[c].id,
                targetType: "DEF"
              };
              vm.editedItem.authFuncPermissionList.push(objTmp);
            }
          }
        }
        //console.log(JSON.stringify(vm.editedItem.authFuncPermissionList));
      }
      //console.log("data" + JSON.stringify(vm.editedItem));
      //console.log("action Edit Item" + vm.editedIndex);
      vm.axios
        .put(vm.idbServerUrl + "idb/auth/AuthRole", vm.editedItem, {
          headers: {
            "Content-Type": "application/json",
            Authorization: vm.$localStorage.get("idb_login_token")
          }
        })
        .then(function(response) {
          console.log("response " + JSON.stringify(response));
          vm.successSwalUtil();
          vm.getInterpreterFromServer();
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log(error);
        });
      vm.canceldata();
    },

    updateItemsPerPage(number) {
      this.itemsPerPage = number;

      this.getInterpreterFromServer();
    },
    getTableDataFormServer(item) {
      var vm = this;
      vm.axios
        .get(vm.idbServerUrl + "idb/auth/AuthRole/" + item.roleId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: vm.$localStorage.get("idb_login_token")
          }
        })
        .then(function(response) {
          //var dataResponse = JSON.stringify(response.data);
          //console.log("tableDatadataResponse " + dataResponse);
          vm.tableData = response.data;
          vm.getAuthFuncIndexFormServer();
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          console.log(error);
        });
    },
    getAuthFuncIndexFormServer() {
      var vm = this;
      //vm.queryObject.depth="1";
      //var queryObjectStr = JSON.stringify(vm.queryObject);
      var queryObjectStr = JSON.stringify({ depth: "0", status: "Y" });
      var queryPagerStr = JSON.stringify({
        pageSize: vm.queryPager.pageSize,
        currentPage: vm.queryPager.currentPage
        // sortColumnNameList: ["apcatId"]
      });
      var criterionStr = JSON.stringify({});
      vm.axios
        .get(
          vm.idbServerUrl +
            "idb/auth/authFunc?queryString=" +
            encodeURIComponent(queryObjectStr) +
            "&queryPager=" +
            encodeURIComponent(queryPagerStr) +
            "&criterion=" +
            encodeURIComponent(criterionStr),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          //var dataResponse = JSON.stringify(response.data.resultList);
          //console.log("dataResponse " + dataResponse);
          vm.authFuncIndexObject = response.data.resultList;
          vm.getAuthFuncFormServer();
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          console.log(error);
        });
    },
    getAuthFuncFormServer() {
      var vm = this;

      var queryObjectStr = JSON.stringify({ depth: "1", status: "Y" });
      var queryPagerStr = JSON.stringify({
        pageSize: vm.queryPager.pageSize,
        currentPage: vm.queryPager.currentPage
        // sortColumnNameList: ["apcode"]
      });
      var criterionStr = JSON.stringify({});
      vm.axios
        .get(
          vm.idbServerUrl +
            "idb/auth/authFunc?queryString=" +
            encodeURIComponent(queryObjectStr) +
            "&queryPager=" +
            encodeURIComponent(queryPagerStr) +
            "&criterion=" +
            encodeURIComponent(criterionStr),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          //var dataResponse = JSON.stringify(response.data.resultList);
          // console.log("dataResponse " + dataResponse);
          vm.authFuncObject = response.data.resultList;

          // console.log("tableData " + vm.tableData.length);
          // console.log("apCatObject " + vm.apCatObject.length);
          // console.log("apObject " + vm.apObject.length);
          //console.log(vm.items);
          vm.processAPDATA(
            vm.tableData,
            vm.authFuncIndexObject,
            vm.authFuncObject
          );
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log(error);
        });
    },
    fold: function(item) {
      if (typeof item.folded === "undefined") {
        this.$set(item, "folded", true);
      } else {
        item.folded = !item.folded;
      }
    },
    processAPDATA: function(objData, objAuthFuncIndex, objAuthFunc) {
      var vm = this;
      for (let a = 0; a < objAuthFuncIndex.length; a++) {
        var checkedYNIndex = 0;
        for (let c = 0; c < objData.authFuncPermissionList.length; c++) {
          //console.log("targetId" + objData.authFuncPermissionList[c].funcId);
          //console.log("objAuthFuncId" + objAuthFuncIndex[a].funcId);
          if (
            objData.authFuncPermissionList[c].funcId ===
            objAuthFuncIndex[a].funcId
          ) {
            checkedYNIndex = 1;
            //console.log("checkedYN  " + checkedYNIndex);
          }
        }
        var objTmp = {
          title: objAuthFuncIndex[a].name,
          id: objAuthFuncIndex[a].funcId,
          description: objAuthFuncIndex[a].description,
          YN: checkedYNIndex,
          second: []
        };
        for (let b = 0; b < objAuthFunc.length; b++) {
          //console.log(objAuthFunc[b].apcat + " - " + objAuthFunc[b].apcode);

          if (objAuthFunc[b].parentFunc.funcId === objTmp.id) {
            //console.log(objAuthFunc[b].apcat + " - " + objAuthFunc[b].apcode);
            // var checkYN = false;
            var checkedYN = 0;
            for (let c = 0; c < objData.authFuncPermissionList.length; c++) {
              //console.log("objData[c].apcode  " + objData[c].comp_id.apcode + " --- " + objAuthFunc[b].apcode);
              if (
                //objData[c].comp_id.apcode === objAuthFunc[b].apcode &&
                // objData[c].rights > 0
                objData.authFuncPermissionList[c].funcId ===
                objAuthFunc[b].funcId
              ) {
                checkedYN = 1;
              }
            }
            objTmp.second.push({
              title: objAuthFunc[b].name,
              id: objAuthFunc[b].funcId,
              YN: checkedYN
            });
          }
        }
        vm.finalObject.push(objTmp);
      }
    },

    getInterpreterFromServer() {
      var vm = this;
      vm.loading = true;
      const { sortBy, sortDesc } = this.options;

      var sortColumnNameList = ["-postDate"];
      sortBy.forEach((element, index) => {
        sortColumnNameList[index] = (sortDesc[index] ? "-" : "") + element;
      });
      var queryObjectStr = JSON.stringify(vm.queryObject);

      var queryPagerStr = JSON.stringify({
        pageSize: vm.itemsPerPage,
        currentPage: vm.currentPage
        // sortColumnNameList: sortColumnNameList
      });
      var criterionStr = JSON.stringify({});
      vm.axios
        .get(
          vm.idbServerUrl +
            "idb/auth/AuthRole?queryString=" +
            encodeURIComponent(queryObjectStr) +
            "&queryPager=" +
            encodeURIComponent(queryPagerStr) +
            "&criterion=" +
            encodeURIComponent(criterionStr),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          //var dataResponse = JSON.stringify(response.data.resultList)
          //console.log(JSON.stringify(response))
          vm.currentPage = response.data.currentPage;
          vm.maxPage = response.data.maxPage;
          vm.pageSize = response.data.pageSize;
          vm.totalCount = response.data.totalCount;
          vm.items = response.data.resultList;
          vm.loading = false;
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log(error);
        });
    }
  },
  mounted() {
  }
};
</script>




